import posthog from "posthog-js";
import { Capacitor } from "@capacitor/core";
import { supabase } from "@/lib/supabase";

const POSTHOG_KEY = "phc_scXmQsEScHobsYXfmrzwmiPv7mHnjL3smnh42xFCp9f7";
const POSTHOG_HOST = "https://us.i.posthog.com";

let initialized = false;

function getSessionId(): string {
  try {
    let sid = sessionStorage.getItem("aa_sid");
    if (!sid) {
      sid = (crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random().toString(36).slice(2)}`);
      sessionStorage.setItem("aa_sid", sid);
    }
    return sid;
  } catch {
    return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }
}

const platform = () => (Capacitor.isNativePlatform() ? "app" : "web");

export function initAnalytics() {
  if (initialized || typeof window === "undefined") return;
  initialized = true;
  try {
    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      persistence: "memory",
      disable_session_recording: true,
      autocapture: true,
      capture_pageview: false,
      capture_pageleave: false,
      disable_persistence: true,
    });
  } catch (e) {
    console.warn("[analytics] PostHog init falhou", e);
  }
}

type TrackOptions = {
  type?: "page_view" | "click" | "funnel";
  path?: string;
  props?: Record<string, unknown>;
  isAuthed?: boolean;
};

export async function track(eventName: string, opts: TrackOptions = {}) {
  const type = opts.type ?? "click";
  const path = opts.path ?? (typeof window !== "undefined" ? window.location.pathname : "");
  try {
    posthog.capture(eventName, { ...opts.props, path, platform: platform() });
  } catch { /* ignore */ }
  try {
    await supabase.from("analytics_events").insert({
      session_id: getSessionId(),
      event_type: type,
      event_name: eventName,
      path,
      props: opts.props ?? {},
      platform: platform(),
      is_authed: !!opts.isAuthed,
    });
  } catch { /* ignore */ }
}

export function trackPageView(path: string, isAuthed = false) {
  track("page_view", { type: "page_view", path, isAuthed });
}
